const tiers = [
  "Rookie Saver",
  "Solid Saver",
  "Savvy Saver",
  "Super Saver",
  "Expert Saver"
];


const calculateGamification = function(data) {
  console.log(data);
  if(typeof data === 'undefined') return;

  var redemptionsPerStar = 12;

  var subscribers = data.subscribers;

  var cause = data.cause;

  var redemptionCount = data.redemption_count || 0;

  var redemptionsPerLevel = redemptionsPerStar * 5;

  var maxRedemptions = tiers.length * redemptionsPerLevel;

  var tierName = Math.round(Math.min(redemptionCount / redemptionsPerLevel, tiers.length - 1));
  return {
    progress: (redemptionCount > maxRedemptions) ? 1.0 : parseFloat(redemptionCount % redemptionsPerStar) / parseFloat(redemptionsPerStar),
    numberOfStars: Math.floor((redemptionCount > maxRedemptions) ? 5 : (redemptionCount % redemptionsPerLevel) / redemptionsPerStar),
    redemptionsNeeded: (redemptionCount > maxRedemptions) ? null : redemptionsPerStar - (redemptionCount % redemptionsPerStar),
    redemptionCount: redemptionCount,
    tierName: tiers[tierName],
    nextLevel: {
      count: ((maxRedemptions - redemptionCount) % redemptionsPerLevel) || redemptionsPerLevel,
      tier: tiers[tierName + 1]
    }
  };
}

const templateUrl = require('./../views/partials/savings-status-card.html');

function savingsStatusCardDirective($timeout) {
  'ngInject';

  return {
    scope: {
      gameInfo: '&'
    },
    templateUrl,
    restrict: 'E',
    link: function(scope, el, attrs) {
      var gameInfo = scope.gameInfo();
      scope.game = calculateGamification(gameInfo);

      if(typeof scope.game === 'undefined') return;

      //***** Caclulate stars ***//
      var l = scope.game.numberOfStars;
      scope.filledStars = new Array(l);
      scope.emptyStars = new Array(5 - l);


      //***** Animate progress circle ***//
      var $circle = $('#progress');
      var r = $circle.attr('r');
      var c = Math.PI * (r * 2);
      var val = scope.game.progress * 100;
      var pct = ((100 - val) / 100) * c;
      $timeout(function() {
        $circle.css({
          strokeDashoffset: pct
        });
      }, 300);
    }
  };
}

export default savingsStatusCardDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/savingsStatusCard.js